<section class="bg-bg h-screen animate-fade-in z-0 bg-cover bg-center bg-no-repeat" style="background-image: url('/assets/img/fondo-login.jpg')">
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
    <div class="w-full bg-white rounded-3xl shadow md:mt-0 sm:max-w-lg xl:p-0 animate-fade-in-up">
      <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
        <div class="flex items-center justify-center text-2xl animate-fade-in-down mb-12">
          <img class="w-30 mr-2" src="/assets/img/logo.svg" alt="logo">
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</section>


